export const textStyles = {
  baseStyle: {},
  sizes: {},
  variants: {},
};
